import { Link, Match } from "@reach/router";
import React from "react";

type NavLinkProps = {
  path: string;
  closeBurgerMenu: () => void;
  disabled?: boolean;
  icon?: string;
};

export const NavLink: React.FC<NavLinkProps> = ({
  path,
  children,
  closeBurgerMenu,
  disabled,
  icon,
}) => {
  return (
    <Match path={path}>
      {({ match }) => (
        <Link
          to={path}
          className={`${disabled ? "Disabled" : ""}`}
          onClick={closeBurgerMenu}
        >
          <div className={`NavLink ${match ? "Active " : ""}`}>
            {icon && <img src={icon} className="NavLink__icon" />}
            {children && <span className="NavLink__text">{children}</span>}
          </div>
        </Link>
      )}
    </Match>
  );
};

// function ListItemLink({ to, children }) {
//     return (
//         <Match path={to}>
//             {({ match }) => (
//                 <li className={match ? "active" : ""}>
//                     <Link to={to}>{children}</Link>
//                 </li>
//             )}
//         </Match>
//     );
// }

// <ul>
//     <ListItemLink to="/somewhere">Hey hey!</ListItemLink>
// </ul>
